module.exports = __webpack_public_path__ + "static/media/album_cover_ginger.6581e111.jpg";